// extracted by mini-css-extract-plugin
export var button = "arrow-text-button-module--button--TF2Fs";
export var content = "arrow-text-button-module--content--S0K8a";
export var image = "arrow-text-button-module--image--ERC6M";
export var innerWrapper = "arrow-text-button-module--inner-wrapper--JTUve";
export var outerWrapper = "arrow-text-button-module--outer-wrapper--+AtXs";
export var text = "arrow-text-button-module--text--Wd+OU";